export default __webpack_public_path__ + "static/media/default.39c160bb5c3f43980715701119484156.png";